// extracted by mini-css-extract-plugin
module.exports = {"layoutContainer":"layout-module--layout-container--MPpVJ","layoutContent":"layout-module--layout-content--aP5Kz"};